"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergeStylesDefaultContext = exports.getNewContext = exports.noopUndefined = exports.noopRootStylesheets = exports.noopShadow = exports.noop = void 0;
var merge_styles_1 = require("@fluentui/merge-styles");
var React = require("react");
var noop = function () { return false; };
exports.noop = noop;
var noopShadow = function () { return merge_styles_1.DEFAULT_SHADOW_CONFIG; };
exports.noopShadow = noopShadow;
var noopRootStylesheets = function () { return new Map(); };
exports.noopRootStylesheets = noopRootStylesheets;
var noopUndefined = function () { return undefined; };
exports.noopUndefined = noopUndefined;
var getNewContext = function () {
    return {
        stylesheets: new Map(),
        useAdoptedStylesheetEx: exports.noop,
        useAdoptedStylesheet: exports.noop,
        useShadowConfig: exports.noopShadow,
        useMergeStylesShadowRootContext: exports.noopUndefined,
        useHasMergeStylesShadowRootContext: exports.noop,
        useMergeStylesRootStylesheets: exports.noopRootStylesheets,
        useWindow: exports.noopUndefined,
        useStyled: exports.noopUndefined,
    };
};
exports.getNewContext = getNewContext;
exports.MergeStylesDefaultContext = React.createContext((0, exports.getNewContext)());
//# sourceMappingURL=MergeStylesDefaultContext.js.map